import React from 'react';
import { useTranslation } from '@/i18n';

import { AlertCard } from '@/ui/layout';
import { BodyCopy, BodySmall } from '@/ui/typography';
import { Spacer } from '@/ui/spacing';

export const InvalidRateCodeAlert = () => {
  const { t } = useTranslation('search');

  return (
    <AlertCard
      type="warning"
      css={{
        '@media (max-width: 639px)': {
          margin: '0 16px',
        },
      }}
    >
      <BodyCopy css={{ fontWeight: 600 }}>
        {t('form.invalidRateCodeWarning.title')}
      </BodyCopy>
      <Spacer s="xs" />
      <BodySmall>{t('form.invalidRateCodeWarning.description')}</BodySmall>
    </AlertCard>
  );
};
